import type { CSSProperties } from "react";

/*
 * The app's soft white bar (MR !1552, owner's variant B, 2026-10-17), brought
 * to the phone site (owner, 2026-10-18). An opaque soft-white capsule with a
 * white rim, and the tab you are on pressed INTO it as a grey well carrying its
 * icon and name. Same values as `apps/mobile/src/shared/ui/bottom-nav/primary.tsx`.
 *
 * The drop shadow belongs to the capsule and the + only. The well is inset
 * light and shade: a selected tab never casts a shadow.
 */
export const SOFT_SHADOW = "0 7px 16px rgba(4,0,51,0.11), 0 0 0 1px rgba(17,14,57,0.06)";
const SOFT_RIM = "inset 0 0 0 1px #FFFFFF";

/** The material itself: fill and white rim, no drop shadow. */
export const SOFT_FILL: CSSProperties = {
  background: "linear-gradient(180deg, #FBFBFD 0%, #F1F1F5 100%)",
  boxShadow: SOFT_RIM,
};

/** The capsule: the material plus its shadow, on one node (nothing clips it). */
export const SOFT_SURFACE: CSSProperties = {
  ...SOFT_FILL,
  boxShadow: `${SOFT_SHADOW}, ${SOFT_RIM}`,
};

export const SOFT_WELL_FILL = "#E8E8EE";
export const SOFT_WELL: CSSProperties = {
  background: SOFT_WELL_FILL,
  boxShadow: "inset 0 2px 5px rgba(17,14,57,0.14), inset 0 -1px 0 #FFFFFF",
};
